import { sortBy } from '../../utils';
import {
  DEFAULT_TASK_INSTANCES_GROUP_METHOD,
  TASK_INSTANCES_GROUP_BY_NONE,
  TASK_INSTANCES_GROUP_BY_LOCATION,
  TASK_INSTANCES_GROUP_BY_POSITION,
  TASK_INSTANCES_GROUP_BY_STATUS,
  TASK_INSTANCE_PENDING_STATUS,
  TASK_INSTANCE_COMPLETED_STATUS,
  DEFAULT_TASK_INSTANCES_SORT_METHOD,
  TASK_INSTANCES_SORT_BY_STATUS,
} from '../../constants';

const methodMap = {
  [TASK_INSTANCES_GROUP_BY_NONE]: noGrouping,
  [TASK_INSTANCES_GROUP_BY_LOCATION]: groupByLocation,
  [TASK_INSTANCES_GROUP_BY_POSITION]: groupByPosition,
  [TASK_INSTANCES_GROUP_BY_STATUS]: groupByStatus,
};

export default function groupTaskInstances(
  taskInstances,
  groupMethod,
  sortMethod = DEFAULT_TASK_INSTANCES_SORT_METHOD
) {
  const method = methodMap[groupMethod] || methodMap[DEFAULT_TASK_INSTANCES_GROUP_METHOD];
  const result = method(taskInstances);

  Object.keys(result).forEach((groupKey) => {
    if (sortMethod === TASK_INSTANCES_SORT_BY_STATUS) {
      result[groupKey].sort(sortByStatus);
    } else {
      sortBy(result[groupKey], sortMethod);
    }
  });

  return result;
}

export function noGrouping(taskInstances) {
  return taskInstances.reduce(
    (groupped, instance) => {
      if (instance.available) {
        groupped.available.push(instance);
      } else if (!instance.assigneeId) {
        groupped.unassigned.push(instance);
      } else {
        groupped.all.push(instance);
      }

      return groupped;
    },
    {
      unassigned: [],
      available: [],
      all: [],
    }
  );
}

export function groupByLocation(taskInstances) {
  return taskInstances.reduce(
    (groupped, instance) => {
      if (instance.available) {
        groupped.available.push(instance);
      } else if (!instance.assigneeId) {
        groupped.unassigned.push(instance);
      } else {
        if (!groupped[instance.locationId]) {
          groupped[instance.locationId] = [];
        }
        groupped[instance.locationId].push(instance);
      }

      return groupped;
    },
    {
      unassigned: [],
      available: [],
    }
  );
}

export function groupByPosition(taskInstances) {
  return taskInstances.reduce(
    (groupped, instance) => {
      if (instance.available) {
        groupped.available.push(instance);
      } else if (!instance.assigneeId) {
        groupped.unassigned.push(instance);
      } else {
        if (!groupped[instance.positionId]) {
          groupped[instance.positionId] = [];
        }
        groupped[instance.positionId].push(instance);
      }

      return groupped;
    },
    {
      unassigned: [],
      available: [],
    }
  );
}

export function groupByStatus(taskInstances) {
  return taskInstances.reduce(
    (groupped, instance) => {
      if (instance.available) {
        groupped.available.push(instance);
      } else if (!instance.assigneeId) {
        groupped.unassigned.push(instance);
      } else if (instance.status === TASK_INSTANCE_PENDING_STATUS) {
        groupped.pending.push(instance);
      } else {
        groupped.done.push(instance);
      }

      return groupped;
    },
    {
      unassigned: [],
      available: [],
      pending: [],
      done: [],
    }
  );
}

export function sortByStatus(taskInstanceA, taskInstanceB) {
  if (taskInstanceA.isPublished && !taskInstanceB.isPublished) {
    return 1;
  }

  if (!taskInstanceA.isPublished && taskInstanceB.isPublished) {
    return -1;
  }

  if (
    taskInstanceA.status === TASK_INSTANCE_PENDING_STATUS &&
    taskInstanceB.status === TASK_INSTANCE_COMPLETED_STATUS
  ) {
    return -1;
  }

  return taskInstanceA.status === TASK_INSTANCE_COMPLETED_STATUS &&
    taskInstanceB.status === TASK_INSTANCE_PENDING_STATUS
    ? 1
    : 0;
}
